import Link from 'next/link'
import React from 'react'

import {CustomerSummary} from '@/src/services/UserService/types'

const BeConsultant = ({
  customerSummary,
}: {
  customerSummary: CustomerSummary | null
}) => {
  if (!customerSummary?.advisorStatus) {
    return (
      <Link
        href="/danisman/kayit-ol"
        className=" hidden lg:flex text-primary text-xs border border-primary rounded-full px-4 py-2 items-center">
        DANIŞMAN OL
      </Link>
    )
  }

  if (customerSummary.advisorStatus === 'CREATED') {
    return (
      <Link
        href="/danisman-kaydi/adim1"
        className="hidden lg:flex text-primary text-xs border border-primary rounded-full px-4 py-2 items-center">
        BAŞVURUYA DEVAM ET
      </Link>
    )
  } else {
    return null
  }
}

export default BeConsultant
